import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@chakra-ui/react';
import { BOOKING_CHANNEL, FT_PI_NO_ROOM_TYPE_SEARCH } from '@whitbread-eos/api';
import { OneAdult, Dropdown, InfoMessage, Icon } from '@whitbread-eos/atoms';
import { createOptionsAdultsChildrenDropdown, getAdultsChildrenOptions, getCookie, BUNDLE_CHOICE, useFeatureToggle, BUNDLE_CHOICE_OPTIONS, tabbingAccessibility } from '@whitbread-eos/utils';
import { nanoid } from 'nanoid';
import { useState, useRef } from 'react';
import DropdownContent from './DropdownContent.component';
import { CHILDREN_KEY, ADULTS_NUMBER_KEY, CHILDREN_NUMBER_KEY, ADULTS_KEY, SHOULD_BE_ACCESSIBLE } from './constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function RoomPicker(_ref) {
  var onSubmit = _ref.onSubmit,
    boxWrapperStyles = _ref.boxWrapperStyles,
    roomPickerInputElementStyles = _ref.roomPickerInputElementStyles,
    roomPickerSize = _ref.roomPickerSize,
    initialState = _ref.initialState,
    labels = _ref.labels,
    maxNumberOfRooms = _ref.maxNumberOfRooms,
    dataRoomOccupancyLimitations = _ref.dataRoomOccupancyLimitations,
    roomCodes = _ref.roomCodes,
    screenSize = _ref.screenSize,
    showErrorMessage = _ref.showErrorMessage,
    errorMessage = _ref.errorMessage,
    showMultipleRooms = _ref.showMultipleRooms,
    channel = _ref.channel;
  var focusableRefs = useRef([]);
  var _useFeatureToggle = useFeatureToggle(),
    isNoRoomTypeSearchEnabled = _useFeatureToggle[FT_PI_NO_ROOM_TYPE_SEARCH];
  var noRoomTypeSearch = isNoRoomTypeSearchEnabled && getCookie(BUNDLE_CHOICE) === BUNDLE_CHOICE_OPTIONS.noRoomTypeSearch;
  var createRoom = labels => ({
    id: nanoid(),
    adults: 1,
    children: 0,
    shouldIncludeCot: false,
    shouldBeAccessible: false,
    roomType: labels.double
  });
  var rooms = initialState;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isContentDisplayed = _useState2[0],
    setIsContentDisplayed = _useState2[1];
  var addRoom = () => {
    if (rooms.length < maxNumberOfRooms) {
      var newRooms = [...rooms, createRoom(labels)];
      onSubmit(newRooms);
    }
  };
  var removeRoom = roomId => {
    var newRooms = rooms.filter(room => room.id !== roomId);
    onSubmit(newRooms);
  };
  var updateRoom = (roomId, option, value, labels) => {
    var newRooms = rooms.map(room => {
      if (room.id !== roomId) {
        return room;
      } else {
        var extraChanges = {};
        if (option === ADULTS_KEY && Number(value) > 0 && channel !== BOOKING_CHANNEL.CCUI) {
          if (room.roomType === (labels === null || labels === void 0 ? void 0 : labels.twin) && value === 1) {
            extraChanges = {
              roomType: labels === null || labels === void 0 ? void 0 : labels.double
            };
          }
          if (room.roomType === (labels === null || labels === void 0 ? void 0 : labels.single) && value === 2) {
            extraChanges = {
              roomType: labels === null || labels === void 0 ? void 0 : labels.double
            };
          }
        }
        if (option === CHILDREN_KEY) {
          if (value === 0) {
            extraChanges = {
              roomType: labels === null || labels === void 0 ? void 0 : labels.double
            };
          } else {
            extraChanges = {
              roomType: labels === null || labels === void 0 ? void 0 : labels.family,
              [SHOULD_BE_ACCESSIBLE]: false
            };
          }
        }
        if (option === SHOULD_BE_ACCESSIBLE) {
          room.roomType = labels.accessible;
        }
        return _objectSpread(_objectSpread({}, room), {}, {
          [option]: value
        }, extraChanges);
      }
    });
    onSubmit(newRooms);
  };
  var _onSubmit = () => {
    onSubmit(rooms);
  };
  var isLessThanSm = screenSize.isLessThanSm;
  var dropdownWrapperStyles = _objectSpread(_objectSpread(_objectSpread({}, wrapperStyles), boxWrapperStyles), showErrorMessage && !isContentDisplayed && _objectSpread({}, errorWrapperStyles));
  var menuBtnStyles = _objectSpread(_objectSpread(_objectSpread({}, menuButtonStyles), roomPickerInputElementStyles), showErrorMessage && !isContentDisplayed && _objectSpread({}, errorMenuButtonStyles));
  return _jsxs(Box, _objectSpread(_objectSpread({
    position: "relative"
  }, roomPickerSize), {}, {
    children: [_jsx(Dropdown, {
      dropdownStyles: {
        wrapperStyles: dropdownWrapperStyles,
        menuButtonStyles: menuBtnStyles,
        menuButtonWrapperStyles: menuButtonWrapperStyles,
        errorHoverMenuButtonStyles: showErrorMessage && !isContentDisplayed ? errorHoverMenuButtonStyles : {}
      },
      icon: _jsx(Icon, {
        svg: _jsx(OneAdult, {})
      }),
      skipChevron: true,
      placeholder: getPlaceholder(rooms, labels),
      dataTestId: "roomPicker-dropdown",
      onDisplayContent: isOpen => {
        if (isOpen && focusableRefs) {
          focusableRefs.current = [];
        }
        handleDisplayContent(isOpen);
      },
      tabbingAccessibility: tabbingAccessibility,
      focusableRefs: focusableRefs,
      children: props => _jsx(DropdownContent, _objectSpread(_objectSpread({}, props), {}, {
        showMultipleRooms: showMultipleRooms,
        onSubmit: _onSubmit,
        rooms: rooms,
        addRoom: addRoom,
        removeRoom: removeRoom,
        updateRoom: updateRoom,
        labels: labels,
        maxNumberOfRooms: maxNumberOfRooms,
        dataRoomOccupancyLimitations: dataRoomOccupancyLimitations,
        adultsOptions: createOptionsAdultsChildrenDropdown(getAdultsChildrenOptions(dataRoomOccupancyLimitations, ADULTS_NUMBER_KEY), labels.adult, labels.adults),
        childrenOptions: createOptionsAdultsChildrenDropdown(getAdultsChildrenOptions(dataRoomOccupancyLimitations, CHILDREN_NUMBER_KEY), labels.child, labels.children),
        dataTestId: "roomPicker-dropdownContent",
        roomCodes: roomCodes,
        screenSize: screenSize,
        channel: channel,
        className: 'roompicker-room-type',
        noRoomTypeSearch: noRoomTypeSearch,
        tabbingAccessibility: tabbingAccessibility,
        focusableRefs: focusableRefs
      }))
    }), !isLessThanSm && showErrorMessage && errorMessage && _jsx(InfoMessage, {
      infoMessage: errorMessage,
      otherStyles: alertStyles
    })]
  }));
  function handleDisplayContent(isContentDisplayed) {
    setIsContentDisplayed(isContentDisplayed);
  }
}
function getTotalPeople(state) {
  return state.reduce((acc, cur) => {
    acc.adults += +cur.adults;
    acc.children += +cur.children;
    return acc;
  }, {
    adults: 0,
    children: 0
  });
}
function getPlaceholderString(obj, labels) {
  var adult = labels.adult,
    adults = labels.adults,
    child = labels.child,
    children = labels.children,
    room = labels.room,
    rooms = labels.rooms;
  var adultsLabel = obj.adults === 1 ? adult : adults;
  var childLabel = obj.children === 1 ? child : children;
  var childrenLabel = obj.children === 0 ? '' : childLabel;
  var roomsLabel = obj.rooms === 1 ? room : rooms;
  return obj.children === 0 ? "".concat(obj.adults, " ").concat(adultsLabel, ", ").concat(obj.rooms, " ").concat(roomsLabel) : "".concat(obj.adults, " ").concat(adultsLabel, ", ").concat(obj.children, " ").concat(childrenLabel, ", ").concat(obj.rooms, " ").concat(roomsLabel);
}
function getPlaceholder(state, labels) {
  var totalRooms = state.length;
  var totalPeople = getTotalPeople(state);
  return getPlaceholderString(_objectSpread(_objectSpread({}, totalPeople), {}, {
    rooms: totalRooms
  }), labels);
}
var menuButtonStyles = {
  bgColor: 'transparent',
  border: '0.063rem solid transparent',
  _hover: {
    border: '0.063rem solid var(--chakra-colors-darkGrey1)'
  },
  _active: {
    border: '0.125rem solid var(--chakra-colors-primary)'
  },
  _focusVisible: {
    border: '0.125rem solid var(--chakra-colors-primary)'
  }
};
var errorHoverMenuButtonStyles = {
  _hover: {
    border: 'none'
  }
};
var errorMenuButtonStyles = {
  borderWidth: '0',
  _active: {
    border: 'none'
  }
};
var wrapperStyles = {
  mt: '3rem'
};
var errorWrapperStyles = {
  borderRadius: 'var(--chakra-space-radiusSmall)',
  border: '2px solid var(--chakra-colors-error)'
};
var menuButtonWrapperStyles = {
  display: 'block',
  height: '100%',
  marginLeft: '-1px'
};
var alertStyles = {
  w: 'full',
  zIndex: 1
};